<template>
  <div class="circle__chart" >
    <svg class="circle-chart" viewbox="0 0 33.83098862 33.83098862" :width="dim" :height="dim" xmlns="http://www.w3.org/2000/svg">
      <circle class="circle-chart__background" stroke="#efefef" stroke-width="1" fill="none" :cx="dim/2" :cy="dim/2" :r="dim/2" />
      <circle class="circle-chart__circle" stroke="#00acc1" stroke-width="4" :stroke-dasharray="mydasharray" :stroke-dashoffset="mydashoffset" stroke-linecap="round" fill="none" :cx="dim/2" :cy="dim/2" :r="dim/2" />
      <g class="circle-chart__info">
        <text class="circle-chart__percent" x="16.91549431" y="15.5" alignment-baseline="central" text-anchor="middle" font-size="8">{{this.currentvalue}}</text>
        <text class="circle-chart__subline" x="16.91549431" y="20.5" alignment-baseline="central" text-anchor="middle" font-size="2"></text>
      </g>
    </svg> 
  </div>
</template>

<script>
export default {
  name: "",
  props: [
    "currentvalue", "totalvalue", "dim"
  ],
  data:function(){ 
    return {

    }
  },
  computed: {
    mydasharray: function() {
      let circunf = 2 * Math.PI * (this.dim / 2);
      return ""+circunf+""; 
    },
    mydashoffset: function() {
      let myoffset = this.mydasharray * (1 - (this.currentvalue / this.totalvalue));
      return ""+myoffset+""; 
    },
  },
  methods: {
 
  }
}
</script>

<style scoped>
  .orphan-card {
    margin-top: calc(55px + 0.5rem);
  }
</style>